/* Moved from sections/hlth-hero-v2.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var section = document.querySelector('.hlth-hero2-' + SID + '');
        if (!section) return;
        var video = section.querySelector('.hlth-hero2-video');
        var poster = section.querySelector('.hlth-hero2-poster');
        if (video && poster) {
          video.addEventListener('playing', function() {
            poster.style.opacity = '0';
            poster.style.transition = 'opacity 0.5s ease';
          }, { once: true });
        }

        /* ---- MOBILE AUTOPLAY KICKSTART ----
           iOS Safari silently rejects autoplay when Low Power Mode is on, Reduce
           Motion is enabled, or Safari auto-play is disabled — the result is a
           paused video with a native "tap to play" triangle. We can't override
           those OS-level blocks, but we can:
           1. Attempt play() explicitly once metadata is loaded (covers cases
              where the declarative autoplay attribute didn't fire due to timing).
           2. Fall back to resuming on the first user interaction anywhere on
              the page (touchstart/scroll/click) so the video starts the moment
              the user engages, even if full autoplay is blocked. */
        if (video) {
          var tryPlay = function() {
            /* No source until after load: play() on an empty video would flip
               paused to false and retire the first-interaction fallback below. */
            if (!video.paused || !(video.currentSrc || video.src)) return;
            var p = video.play();
            if (p && typeof p.catch === 'function') {
              p.catch(function() { /* autoplay blocked — wait for user interaction */ });
            }
          };

          /* ---- HLS ADAPTIVE STREAMING ----
             Safari (iOS + macOS) plays the HLS (.m3u8) source natively via its
             <source> tag, starting with a low-bitrate segment and ramping up —
             time-to-first-frame is typically <1s even on 4G.

             Chromium / Firefox / Edge don't support HLS natively, so we lazily
             load hls.js (~40kb gzipped, the same library Netflix/YouTube/etc
             use) and attach the HLS stream to the video element manually.

             If hls.js fails to load (CDN blocked, offline) or the browser can't
             support Media Source Extensions, we fall back to the MP4. */
          var hlsUrl = video.getAttribute('data-hls-src');
          var mp4Url = video.getAttribute('data-mp4-src');
          var mp4SmUrl = video.getAttribute('data-mp4-sm-src');
          var nativeHls = !!video.canPlayType && !!video.canPlayType('application/vnd.apple.mpegurl');

          var useSrc = function(url) {
            video.src = url;
            video.preload = 'auto';
            video.addEventListener('loadedmetadata', tryPlay, { once: true });
            video.addEventListener('canplay', tryPlay, { once: true });
            video.load();
            tryPlay();
          };

          var fallbackToMp4 = function() {
            if (mp4Url) useSrc(mp4Url);
          };

          /* ---- START AFTER LOAD ----
             Nothing is fetched for the video until the window load event, so the
             poster, fonts and first-screen images get the whole connection. Phones
             (the same 749px breakpoint as the CSS) get the phone MP4 setting (about
             480p) when it is filled in, otherwise the adaptive stream. */
          var startVideo = function() {
            var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
            if (phone && mp4SmUrl) return useSrc(mp4SmUrl);
            if (hlsUrl && nativeHls) return useSrc(hlsUrl);
            if (!hlsUrl) return fallbackToMp4();
            var script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1.5.15/dist/hls.min.js';
            script.async = true;
            script.onload = function() {
              if (window.Hls && window.Hls.isSupported()) {
                var hls = new window.Hls({ enableWorker: true, maxBufferLength: 10 });
                hls.loadSource(hlsUrl);
                hls.attachMedia(video);
                hls.on(window.Hls.Events.MANIFEST_PARSED, tryPlay);
                hls.on(window.Hls.Events.ERROR, function(e, data) {
                  if (data && data.fatal) {
                    try { hls.destroy(); } catch (_) {}
                    fallbackToMp4();
                  }
                });
              } else {
                fallbackToMp4();
              }
            };
            script.onerror = fallbackToMp4;
            document.head.appendChild(script);
          };

          if (document.readyState === 'complete') {
            startVideo();
          } else {
            window.addEventListener('load', startVideo, { once: true });
          }

          var userInteractionKick = function() {
            tryPlay();
            if (!video.paused) {
              document.removeEventListener('touchstart', userInteractionKick, true);
              document.removeEventListener('click', userInteractionKick, true);
              document.removeEventListener('scroll', userInteractionKick, true);
            }
          };
          document.addEventListener('touchstart', userInteractionKick, { capture: true, passive: true });
          document.addEventListener('click', userInteractionKick, true);
          document.addEventListener('scroll', userInteractionKick, { capture: true, passive: true });

          document.addEventListener('visibilitychange', function() {
            if (document.visibilityState === 'visible') tryPlay();
          });
        }

        /* ---- COMPOSITOR HEAL ----
           After long sessions (tab idle for many minutes with continuous video
           playback), Chromium can fail to repaint the hero content layer when the
           tab returns to the foreground or when the user scrolls back to the hero,
           leaving the heading/subheading/button invisible while the proof card
           (which has its own stacking context via backdrop-filter) survives.

           This heal routine forces a repaint of the content layer whenever the tab
           becomes visible again AND whenever the hero re-enters the viewport. The
           transform toggle is a zero-visual-change nudge that invalidates the
           layer and forces the compositor to re-raster it. */
        var content = section.querySelector('.hlth-hero2-content');
        function healContentLayer() {
          if (!content) return;
          // Toggle transform to force a compositor-layer repaint.
          // translateZ(0) keeps the element on its own GPU layer; the micro-offset
          // forces the browser to invalidate and re-raster it.
          content.style.transform = 'translateZ(0.0001px)';
          requestAnimationFrame(function() {
            content.style.transform = '';
          });
        }

        document.addEventListener('visibilitychange', function() {
          if (document.visibilityState === 'visible') {
            healContentLayer();
          }
        });

        // Also heal when the hero re-enters the viewport after being scrolled away.
        if ('IntersectionObserver' in window) {
          var lastVisible = true;
          var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting && !lastVisible) {
                healContentLayer();
              }
              lastVisible = entry.isIntersecting;
            });
          }, { threshold: 0.1 });
          io.observe(section);
        }

        // Belt-and-suspenders: periodically force a repaint while the tab is
        // visible. Cheap no-op in the happy path, decisive fix if the layer ever
        // gets into a bad state.
        setInterval(function() {
          if (document.visibilityState === 'visible') {
            healContentLayer();
          }
        }, 120000); // every 2 minutes

        var proof = section.querySelector('[data-proof]');
        if (!proof) return;
        var quoteEl = proof.querySelector('[data-proof-quote]');
        var authorEl = proof.querySelector('[data-proof-author]');
        var dataEl = proof.querySelector('[data-proof-data]');
        if (!quoteEl || !dataEl) return;
        var quotes = [];
        try { quotes = JSON.parse(dataEl.textContent) || []; } catch (e) {}
        if (quotes.length < 2) return;
        var i = 0;
        setInterval(function() {
          quoteEl.classList.remove('is-visible');
          authorEl.style.opacity = '0';
          setTimeout(function() {
            i = (i + 1) % quotes.length;
            quoteEl.textContent = '\u201C' + quotes[i].text + '\u201D';
            authorEl.textContent = quotes[i].author;
            quoteEl.classList.add('is-visible');
            authorEl.style.opacity = '';
          }, 500);
        }, 6000);
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-hero-v2')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-hero-v2').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_hero_v2) return;
      w.__hlthJs_hlth_hero_v2 = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
